import { keepPreviousData, useQuery } from "@tanstack/react-query";

import type { LeadsColumnsConfigDto } from "app/pages/sales-intelligence/modules/leads-search";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { listsQueryKeys } from "../key-factory/factory";

export const useColumnsConfigQuery = <T = LeadsColumnsConfigDto>(select?: (data: LeadsColumnsConfigDto) => T) => {
    return useQuery<LeadsColumnsConfigDto, unknown, T>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: listsQueryKeys.columnsConfig(),
        placeholderData: keepPreviousData,
        select,
        queryFn({ signal }) {
            return salesApiService.listColumns.fetchColumnConfig({ cancellation: signal });
        },
    });
};
